const sreemangalDetails = [
    {
    id: 4,
    category: "sreemangal",
    name: "Hotel Sky View",
    capacity: "4 guests 2 bedrooms 2 beds  2 baths",
    shortDescription: "Wif Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.9(18)",
    price: 50,
    totalPrice: "167 total",
    details: "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor. A copper plate of Raja Marundanath from the 11th century was found in Kalapur....",
    photo: "https://images.pexels.com/photos/271643/pexels-photo-271643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Sylhet"
},
    {
    id: 5,
    category: "sreemangal",
    name: "Green Leaf Guest",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wilf Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.8(13)",
    price: 52,
    totalPrice: "167 total",
    details: "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor. A copper plate of Raja Marundanath from the 11th century was found in Kalapur....",
    photo: "https://images.pexels.com/photos/3688261/pexels-photo-3688261.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Sylhet"
},
    {
    id: 9,
    category: "sreemangal",
    name: "German Paradise",
    capacity: "4 guests 2 bedrooms 2 beds 2 baths",
    shortDescription: "Wilf Air Condition Kitchen",
    facility: "Cancellation flexibility available",
    stars: "4.8(13)",
    price: 52,
    totalPrice: "167 total",
    details: "It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor. A copper plate of Raja Marundanath from the 11th century was found in Kalapur....",
    photo: "https://images.pexels.com/photos/1743229/pexels-photo-1743229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    origin: "Dhaka",
    Destination: "Sylhet"
}
]
export default sreemangalDetails;